export class SegmentoEntity {
  ativado = true;
  descricao = null;

  constructor(segmento) {
    if (segmento.ativado === false) {
      this.ativado = false;
    }
    this.descricao = segmento.descricao;
  }
}
